import { t } from "../i18n";
import { formatDate } from "../i18n/dates";

export const formatConflictMessage = (result, userData) => {
  const userMap = userData.reduce((map, user) => {
    map[user.id] = user.imieNazwisko;
    return map;
  }, {});
  
  const headerMessage = t("copySchedule.conflictIntro");
  
  const usersWithConflicts = Object.entries(result)
    .map(([userId, dates]) => {
     
      // Was a hand-rolled YYYY-MM-DD -> DD.MM.YYYY reassembly with a hardcoded separator, which
      // would silently drift if the display format ever changed. Routed through the helper.
      const formattedDates = dates.map((date) => formatDate(date)).join(", ");

      const userName = userMap[userId] || t("copySchedule.unknownUser", { id: userId });
      return `<b>${userName}</b>: ${formattedDates}`;
    })
    .join("<br>");
  
  const warningMessage = t("copySchedule.conflictWarning");
  
  return headerMessage + usersWithConflicts + warningMessage;
}; 